import moment from 'moment'
import 'moment/locale/es'
import { getDateString, originsOptions, parseNum, sellerOptions } from './bookings-data'
import { getDataApi, getOptions } from '../services/apiService'
import { checkPermission } from './backoffice-roles-data'
moment.locale('es')

const FILTERS_MIN_DATE = checkPermission('backoffice.booking.filters.allowFilterByDatesPriorTo365days') ?
    undefined :
    getDateString(Date.now() - 365 * 24 * 60 * 60 * 1000) + 'T00:00'

const columnsPayments = [
    {
        name: 'id',
        selector: row => row.id,
        sortable: true,
        width: '100px'
    },
    {
        name: 'Method',
        selector: row => row.method,
        sortable: true
    },
    {
        name: 'Type',
        selector: row => row.type,
        cell: props => {
            if (props.type === 'total') {
                return <span className="badge bg-light-success text-success">{props.type}</span>
            } else {
                return <span className="badge bg-light-warning text-warning">{props.type}</span>
            }
        },
        sortable: true,
        width: '100px'
    },
    {
        name: 'Amount',
        selector: row => row.amount,
        sortable: true,
        width: '100px'
    },
    {
        name: 'Cashier',
        selector: row => row.cashier,
        sortable: true
    },
    {
        name: 'User Id',
        selector: row => row.userId,
        sortable: true,
        width: '100px'
    },
    {
        name: 'Booking Id',
        selector: row => row.bookingId,
        sortable: true
    },
    {
        name: 'Created At',
        selector: row => row.createdAt,
        sortable: true,
        cell: props => moment(props.createdAt).fromNow()
    },
    {
        name: 'Updated At',
        selector: row => row.updatedAt,
        sortable: true,
        cell: props => {return moment(props.updatedAt).fromNow()}
    }
]
export const columnPaymentsMetrics = [
    {
        name: 'method',
        field: 'method',
        selector: row => row.method,
        sortable: true,
    },
    {
        name: 'origin',
        field: 'origin',
        selector: row => row.origin,
        cell: (props) => props.origin === "TOTAL" ? "TOTAL" : `${originsOptions.find(x => x.value === props.origin)?.name||''}` || props.origin,
        sortable: true,
    },
    {
        name: 'venueId',
        field: 'venueId',
        selector: row => row.venueId,
        sortable: true,
    },
    {
        name: 'type',
        field: 'type',
        selector: row => row.type,
        sortable: true,
    },
    {
        name: 'userId',
        field: 'userId',
        selector: row => row.userId,
        cell: (props) => props.userId === "TOTAL" ? "TOTAL" : `${sellerOptions.find(x => x.value === props.userId)?.name||''}` || props.userId,
        sortable: true,
    },
    {
        name: 'amount',
        field: 'amount',
        selector: row => row.amount,
        cell: (props) => <strong>{parseNum("EUR",props.amount)}</strong>,
        sortable: true,
        width: '200px'
    },
    {
        name: 'payments',
        field: 'payments',
        selector: row => row.payments,
        sortable: true,
        width: '100px'
    },
    {
        name: 'bookings',
        field: 'bookings',
        selector: row => row.bookings,
        sortable: true,
        width: '100px'
    },
]

export const defaultFilters = {
    createdAt: [
        getDateString(Date.now()) + 'T00:00', 
        getDateString(Date.now()) + 'T23:59'
    ],
    "Booking.origin": [],
    userId: [],
    method: [],
    type: [],
    "Booking.venueId": 0
}

export const metricsOpts = [
	{ value: 'type', name: 'Tipo' },
	{ value: 'method', name: 'Método' },
	{ value: 'Booking.venueId', name: 'Tablao' },
	{ value: 'userId', name: 'Vendedor' },
	{ value: 'Booking.origin', name: 'Origen' },
]

export const defaultUserPreferences = { autoFilters: 0 }

export const filtersRows = [
    [
        {
            id: 'slct-tablao',
            key: 'Booking.venueId',
            type: 'select',
            role: 'filter',
            label: 'Tablao',
            preferences: ['onlyOne', 'autoHide', 'showCurrentValue', 'toggleSelects'],
            optionsAndTags: () => [
                [
                    { value: 0, name: 'Todos' },
                    { value: 1, name: 'Cardamomo' },
                    { value: 2, name: '1911' },
                ],
                [],
            ],
        },
        {
            id: 'slct-method',
            key: 'method',
            role: 'filter',
            type: 'select',
            placeholder: 'Método',
            preferences: ['selectAllOption', 'showCheckedValuesTag', 'multiSelect', 'toggleSelects'],
            optionsAndTags: async (isSa = false) => [
                [
                    {value: 'creditcard', name: 'Tarjeta'},
                    {value: 'credit', name: 'Erédito'},
                    {value: 'cash', name: 'Efectivo'},
                    {value: 'paygold', name: 'Paygold'},
                    {value: 'other', name: 'Otro'},
                    {value: 'webOther', name: 'Otro - web'},
                    {value: 'noPayment', name: 'Sin pago'},
                    {value: 'webStripe', name: 'Stripe - web'},
                    {value: 'transfer', name: 'Transferencia'},
                    {value: 'webPaypal', name: 'Paypal - web'},
                    {value: 'bizum', name: 'Bizum'},
                    {value: 'autocash', name: 'Autocash'},
                ], []
            ],
        },
        { key: 'createdAt', type: 'datetime-local', label: 'Creación', role: 'filter' , minDate: FILTERS_MIN_DATE},
    ],
    [
        {
            id: 'slct-type',
            key: 'type',
            role: 'filter',
            type: 'select',
            placeholder: 'Tipo',
            preferences: ['selectAllOption', 'showCheckedValuesTag', 'multiSelect', 'toggleSelects'],
            optionsAndTags: async (isSa = false) => [
                [
                    {value: 'partial', name: 'Parcial'},
                    {value: 'total', name: 'Total'},
                ], []
            ],
        },
        {
            id: 'slct-origin',
            key: 'Booking.origin',
            type: 'select',
            role: 'filter',
            placeholder: 'Origen',
            preferences: ['selectAllOption', 'showCheckedValuesTag', 'multiSelect', 'searchable', 'toggleSelects'],
            optionsAndTags: async () => {
                /**
                 * get user objet to obtain permissions
                 */
    
                const includeWebOrigins = checkPermission('backoffice.booking.filters.allowFilterByWebOrigins')
    
                const result = await getDataApi(0, 'origin', 0, 3000, null, null, 'id', 'asc')
                const origins = (result?.data ?? []);
                let tags = {}
                let options = []
                const parents = origins.filter((o) => o.parent === 0)
                origins.forEach((origin) => {
                    if (origin.parent === 3 && !includeWebOrigins) return
                    options.push({ value: origin.id, name: origin.name || origin.id.toString() })
                    let parent = parents.find((p) => p.id === origin.parent)
                    if (parent) {
                        const { name } = parent
                        tags[name] = tags[name] || { name: name, values: [], icon: '', active: false }
                        tags[name].values = [...tags[name].values, origin.id]
                    }
                })
                return [options, Object.values(tags)]
            },
            
        },
        {
            id: 'slct-seller',
            key: 'userId',
            type: 'select',
            role: 'filter',
            placeholder: 'Vendedor',
            preferences: ['selectAllOption', 'showCheckedValuesTag', 'multiSelect', 'searchable', 'toggleSelects'],
            optionsAndTags: async () => {
                const res = await getOptions('userId')
    
                const includeWebOrigins = checkPermission('backoffice.booking.filters.allowFilterByWebOrigins')
                const options = [];
                (res.userId ?? []).forEach(({id, name, origins}) => {
    
                    if (!includeWebOrigins && (id === 9 || id === 10)) return
    
                    options.push({
                        name: name,
                        value: id,
                        dependencies: {
                            origin: origins.split(',')
                        }
                    })
                })
                return [options, []]
            },
        },
    ],
    [
        { key: 'autoFilters' },
        [{ key: 'clearFilters' }, { key: 'applyFilters' }],
    ]
]

export { columnsPayments }


